(function () {
  let observerStarted = false;

  function formatMoney(cents) {
    if (window.Shopify && typeof Shopify.formatMoney === "function") {
      return Shopify.formatMoney(cents);
    }
    return (cents / 100).toLocaleString(undefined, { style: "currency", currency: "USD" });
  }

  async function getCart() {
    const res = await fetch("/cart.js", { credentials: "same-origin" });
    if (!res.ok) throw new Error("Failed to fetch cart");
    return res.json();
  }

  // After discounts subtotal (what customer pays), optionally excluding fee items
  function calcWholesaleSubtotal(cart) {
    const EXCLUDE_SKUS = ["COOLERFEE"];      // TODO: replace with your real fee SKU(s) or leave empty []
    const EXCLUDE_HANDLES = ["cooler-fee"];  // TODO: replace with your real fee handle(s) or leave empty []

    if (!Array.isArray(cart.items)) return cart.total_price || 0;

    return cart.items.reduce((sum, item) => {
      const sku = (item.sku || "").toUpperCase();
      const handle = (item.handle || "").toLowerCase();

      if (EXCLUDE_SKUS.includes(sku)) return sum;
      if (EXCLUDE_HANDLES.includes(handle)) return sum;

      return sum + (item.final_line_price || 0);
    }, 0);
  }

  function setCheckoutDisabled(disabled) {
    const selectors = [
      'button[name="checkout"]',
      'button[type="submit"][name="checkout"]',
      '.cart__checkout-button',
      '#CartDrawer-Checkout',
      'button.cart__checkout-button'
    ];

    selectors.forEach(sel => {
      document.querySelectorAll(sel).forEach(btn => {
        btn.disabled = disabled;
        btn.setAttribute("aria-disabled", disabled ? "true" : "false");
      });
    });
  }

  function updateNotice(subtotalCents) {
    const note = document.getElementById("WholesaleMinimumNote");
    const text = document.getElementById("WholesaleMinimumNoteText");
    if (!note || !text) return;

    const MIN = parseInt(note.getAttribute("data-min-cents") || "15000", 10);

    if (subtotalCents >= MIN) {
      note.style.display = "none";
      setCheckoutDisabled(false);
      return;
    }

    const remaining = MIN - subtotalCents;
    text.textContent = `${formatMoney(MIN)} minimum cart subtotal required. Add ${formatMoney(remaining)} more to checkout.`;
    note.style.display = "flex";
    setCheckoutDisabled(true);
  }

  async function refresh() {
    try {
      const cart = await getCart();
      const subtotal = calcWholesaleSubtotal(cart);
      updateNotice(subtotal);
    } catch (e) {
      console.warn(e);
    }
  }

  function scheduleRefresh(delay = 250) {
    clearTimeout(window.__whMinTO__);
    window.__whMinTO__ = setTimeout(() => refresh().catch(() => {}), delay);
  }

  function startObserver() {
    if (observerStarted) return;
    observerStarted = true;

    const mo = new MutationObserver(() => scheduleRefresh(75));
    mo.observe(document.body, { childList: true, subtree: true });
  }

  document.addEventListener("DOMContentLoaded", () => {
    refresh().catch(() => {});
    startObserver();
  });

  document.addEventListener("change", (e) => {
    if (
      e.target.matches('input[name="updates[]"]') ||
      e.target.matches('input.quantity__input') ||
      e.target.closest(".quantity")
    ) scheduleRefresh(350);
  });

  document.addEventListener("click", (e) => {
    if (
      e.target.closest(".quantity__button") ||
      e.target.closest("[data-quantity-plus]") ||
      e.target.closest("[data-quantity-minus]")
    ) scheduleRefresh(350);
  });
})();
